
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, UsuarioActual } from "../login-controlador";
    import ingreso from './login-ingreso.vue';
    import recuperar from './login-recuperar.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            ingreso,
            recuperar,
        }
    } )
    export default class Componente extends Vue
    {
        get Controlador() { return Model; }
        get UsuarioActual() { return UsuarioActual; }

        Modo: 'inicio' | 'ingreso' | 'recuperar' = 'inicio';

        async mounted()
        {
            this.Controlador.$on( 'tipo', () => this.Modo = this.Controlador.Tipo );
            if ( this.$route.params.id )
            {
                this.Modo = 'recuperar';
                await this.Controlador.IniciarRecuperacion( this.$route.params.id );
            }
        }

    }
